import React from 'react';
import { abbrevNumber } from '../../common/utils';
var Tooltip = function (_a) {
    var amount = _a.amount, records = _a.records, percent = _a.percent, _b = _a.color, color = _b === void 0 ? '#000' : _b;
    return (React.createElement("div", { className: "gaugeChart__tooltip", style: { borderColor: color } },
        records && React.createElement("div", null, abbrevNumber(records) + " " + (records === 1 ? 'record' : 'records')),
        amount && React.createElement("div", null, abbrevNumber(amount) + " amount"),
        percent && React.createElement("div", null, percent + "%")));
};
export default Tooltip;
//# sourceMappingURL=GaugeChartTooltip.js.map